import { createFeatureSelector, createSelector } from '@ngrx/store';

import { StockCheckHistoryState } from './stock-check-history.reducers';

export const stockCheckHistoryKey = 'stockCheckHistory';
export const selectStockCheckHistoryState = createFeatureSelector<StockCheckHistoryState>(stockCheckHistoryKey);

export const selectAllStockCheckHistoryList = createSelector(
  selectStockCheckHistoryState,
  (state: StockCheckHistoryState) => {
    return state?.selected;
  }
);

export const selectStockCheckHistoryListCriteria = createSelector(selectStockCheckHistoryState, (state) => {
  return state?.criteriaObject;
});

export const selectStockCheckHistoryTotalElements = createSelector(selectStockCheckHistoryState, (state) => {
  return state?.totalElements;
});
